
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: 'SignUpReportFailureModal',
  emits: ["close"],
  methods: {
    ...mapActions(['toggleSignUpReportFailureModal']),
    closeModal() {
      document.body.classList.remove("is-popup-opened");
      document.body.classList.add("is-popup-closed");
      setTimeout(() => {
        this.toggleSignUpReportFailureModal();
        document.body.classList.remove("is-popup-closed");
      }, 250);
    },
  },
  computed: {
    ...mapGetters(['showSignUpReportFailureModal']),
  },
});
